import { render, staticRenderFns } from "./user_bonus_log.vue?vue&type=template&id=62b14b74&scoped=true&"
import script from "./user_bonus_log.vue?vue&type=script&lang=js&"
export * from "./user_bonus_log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b14b74",
  null
  
)

export default component.exports